<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 510 510"><path d="M255 23a232.07 232.07 0 0 1 90.3 445.78A232.07 232.07 0 0 1 164.7 41.22 231 231 0 0 1 255 23m0-23C114.17 0 0 114.17 0 255s114.17 255 255 255 255-114.17 255-255S395.83 0 255 0m82.5 326.4h-21V360h-48.6v-33.6h-95.4V282l66.9-132H291l-66.9 132h43.8v-45h48.6v45h21z"/></svg>
</template>
